<template>
    <v-app id="inspire">
        <v-content>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
            <v-flex xs12 sm18 md8 lg4>
                <v-card class="elevation-5 pa-3">
                <!--<v-toolbar class="elevation-1" dark color="primary">
                    <v-toolbar-title>{{ title }}</v-toolbar-title>
                </v-toolbar>-->
                <v-card-text>
                    <div class="layout column align-center">
                    <img :src="getLogo" alt="Nadzorni center - Ponastavitev gesla" width="30%" height="auto">
                    <!--<h1 class="flex mb-2 font-weight-regular">Nadzorni center</h1>-->
                    <br>
                    <h2 class="flex my-2 font-weight-regular">Nadzorni center - Prijava</h2>
                    <v-layout align-center justify-center="">
                        <v-flex xs12 sm12 md12 lg12>
                            <div class="">
                                <p style="text-align:center;">Vnesite elektronski naslov in geslo za vstop v sistem.</p>
                            </div>
                        </v-flex>
                    </v-layout>
                    </div>                
                    <br>
                    <v-form ref="loginForm" v-model="valid" lazy-validation>
                    <v-text-field
                        append-icon="email"
                        name="login" label="E-mail" 
                        type="email" 
                        :rules="emailRules" 
                        v-model="credentials.username"
                        :error="error"
                        :error-messages="errors['message']"
                        @keyup.enter="login"
                        color="tertiary"
                        >
                    </v-text-field>
                    <v-text-field id="password" append-icon="lock" name="password" label="Geslo" type="password" :rules="passwordRules" v-model="credentials.password" @keyup.enter="login" color="tertiary"></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="white--text" dark color="secondary" @click.native="login" :loading="loginLoading">Prijava</v-btn>
                    <v-btn class="white--text" dark color="secondary" @click.native='passwordReset'>Pozabljeno geslo?</v-btn>
                    <br><br>
                </v-card-actions>
                </v-card>
            </v-flex>
            </v-layout>
        </v-container>
        </v-content>
    </v-app>  
</template>

<script>
import router from '@/router'
import { post } from '@/helpers/api'

export default {
    components: {
    },
    props: {
        source: String
    },

    data: () => ({
        title: 'Nadzorni center - Kpss',
        valid: true,
        avatarSize: 32,
        tile: true,
        drawer: null,
        credentials: {
            username: '',
            password: ''
        },

        emailRules: [
            (v) => !!v || 'Elektronski naslov je obvezen.',
            (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Vneseni elektronski naslov ni veljaven.'
        ],
        passwordRules: [
            (v) => !!v || 'Geslo je obvezno.',
            (v) => v.length >= 6 || 'Geslo mora vsebovati vsaj 6 mestni zapis.'
        ],

        loginLoading: false,
        error: false,
        errors: {}
    }),

    computed: {
        getLogo() {
            return 'https://cloud.conforma.si/public/img/eta/eta.png'
        }
    },

    methods: {
        login() {
           if(this.$refs.loginForm.validate()) {
            this.loginLoading = true;
            this.error = false;
            this.errors = {}
            this.credentials.grant_type = "password";
            this.credentials.client_id = "eyJpdiI6IlRQdkRuR09zRjQ4UFVaRUs4NnFJcFE9PSIsInZhbHVlIjoiZHkwamNqVkZaTzJPUnQrR1BONkgyZz09IiwibWFjIjoiNWU5NDU4MGM1MmM0ZDM4M2M2OGI3NmRhZTIyMzQxMGY1NjFlY2MxMmI2MDUwNGI4NTVlM2Y2ZmM0ZDk2M2ZmNSJ9";

            this.$store.dispatch('LOGIN', this.credentials)
              .then(response => {
                router.push({ path: '/'})
              })
              .catch(error => {
                window.console.log("Error")
                window.console.log(error.response)
                window.console.log(error)
                this.error = true;
                this.loginLoading = false;
                if(error.response.status == 401) {
                  this.errors = { message: "Napačno uporabniško ime ali geslo." }
                }
                else {
                  this.errors = { message: "Pri prijavi v sistem je prišlo do napake."}
                }
              })
              .then(() => {
                this.loginLoading = false;
              })
            } 
        },

        passwordReset() {
            this.$router.push({
                name: 'passwordResetRequest'
            })
        }
    },

    created() {

    }
}
</script>

<style scoped>
    html { overflow-y: auto !important; }

    #inspire{
        background-image: url("../../assets/bckpattern.png");
        background-repeat: repeat;
    }
</style>


